// A file's contents as the Files tab shows them: text, or why not (shared by the git worker and the page).
import { isBinary } from '@modelviewer/core';

/** Larger files are not shown or compared. */
export const MAX_TEXT = 2 * 1024 * 1024;

export type FileContent = { kind: 'text'; text: string } | { kind: 'binary'; size: number } | { kind: 'large'; size: number } | { kind: 'missing' };

export function decodeContent(bytes: Uint8Array): FileContent {
  if (bytes.length > MAX_TEXT) return { kind: 'large', size: bytes.length };
  if (isBinary(bytes)) return { kind: 'binary', size: bytes.length };
  // TextDecoder drops a byte order mark at the start.
  return { kind: 'text', text: new TextDecoder().decode(bytes) };
}

/** A file from disk (or a copy of one), read only when it is small enough to show. */
export async function fileContentOf(file: File | null): Promise<FileContent> {
  if (!file) return { kind: 'missing' };
  if (file.size > MAX_TEXT) return { kind: 'large', size: file.size };
  return decodeContent(new Uint8Array(await file.arrayBuffer()));
}
